(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const REVISION = '2026-01-15';

    function show(el, text) {
      if (! el) return;
      


      el.textContent = text || '';
      el.removeAttribute('hidden');
    }

    function hide(el) {
      if (! el) return;
      


      el.setAttribute('hidden', '');
      el.textContent = '';
    }

    function bindForm(form) {
      if (! form || form.dataset.klaviyoBound === 'true') return;
      


      form.dataset.klaviyoBound = 'true';

      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        const companyId = (form.dataset.klCompany || '').trim();
        const listId = (form.dataset.klList || '').trim();
        if (! companyId || ! listId) return;
        


        const emailInput = form.querySelector('input[type="email"]');
        const btn = form.querySelector('button[type="submit"]');
        const okEl = form.querySelector('.waitlist-hero__klaviyo-msg');
        const errEl = form.querySelector('.waitlist-hero__klaviyo-err');
        const email = (emailInput && emailInput.value)
          ? emailInput.value.trim()
          : '';
        if (! email) {
          emailInput && emailInput.focus();
          return;
        }

        hide(okEl);
        hide(errEl);
        btn.setAttribute('disabled', 'true');
        btn.setAttribute('aria-busy', 'true');

        const body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: (form.dataset.klSource || 'P1NK Waitlist').trim(),
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        };

        try {
          const res = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              revision: REVISION
            },
            body: JSON.stringify(body)
          });

          if (res.status === 202 || res.ok) {
            show(okEl, form.dataset.klSuccess || '');
            if (emailInput) 
              emailInput.value = '';
            


          } else {
            let msg = form.dataset.klError || 'Something went wrong.';
            try {
              const j = await res.json();
              if (j && j.errors && j.errors[0] && j.errors[0].detail) {
                msg = j.errors[0].detail;
              }
            } catch (_) {}show(errEl, msg);
          }
        } catch (_) {
          show(errEl, form.dataset.klError || 'Something went wrong.');
        } finally {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-busy');
        }
      });
    }

    function init(scope) {
      const root = scope && scope.querySelectorAll
        ? scope
        : document;
      root.querySelectorAll('form.js-waitlist-klaviyo').forEach(bindForm);
    }

    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });
    document.addEventListener('shopify:section:load', function(ev) {
      init(ev.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
